import { action, reatomMap, withAssign } from '@reatom/framework'

import { SwapRequestModel } from '../model/swap-request-model'

import type { SwapRequest } from '../model/swap-request-model'
import type { TxHash } from '@root/entities/transaction'

const reatomActiveSwaps = () => {
  const mapAtom = reatomMap<string, SwapRequestModel>([], 'mapAtom')

  // eslint-disable-next-line @reatom/unit-naming-rule
  const createAction = action((ctx, request: SwapRequest) => {
    const model = new SwapRequestModel(request)
    mapAtom.set(ctx, request.id, model)
    return model
  })

  const getSwapByTxHash = action((ctx, txHash: TxHash) => {
    const swaps = [...ctx.get(mapAtom).values()]
    return swaps.find((swap) => {
      const stage = ctx.get(swap.stageAtom)
      if ('txHash' in stage) {
        return stage.txHash === txHash
      }
      return false
    })
  }, 'getSwapByTxHash')

  return mapAtom.pipe(
    withAssign(() => ({ create: createAction, getSwapByTxHash })),
  )
}
// eslint-disable-next-line @reatom/unit-naming-rule
export const activeSwapsAtom = reatomActiveSwaps()
